const React = require('react');
const Layout = require('./src/components/layout').default;

/* 代码高亮以及行数 */
require("prismjs/themes/prism-solarizedlight.css");
// require("prismjs/plugins/line-numbers/prism-line-numbers.css")

exports.wrapPageElement = ({ element, props }) => {
  return !props.path.includes('/posts')
    ? <Layout {...props}>{element}</Layout>
    : <>{element}</>;
}